import { Component, Injector, OnInit } from '@angular/core';
import { AbstractControl, FormGroup, UntypedFormBuilder, ValidationErrors, ValidatorFn, Validators } from '@angular/forms';
import { BaseEntityComponent, messageLevel } from "@bndes/bndes-ux4/bndes-angular-utils";
import { ModalidadeGarantiaService } from 'src/app/features/modalidade_garantia/modalidade-garantia.service';
import { ModalidadeGarantia } from 'src/app/model/modalidade_garantia.model';
import { TipoOperacaoEnum } from 'src/app/model/tipo-operacao-enum';
import { ModalidadeService } from 'src/app/shared/services/modalidade.service'; 
import { OperacaorepasseBndesService } from '../../operacao/operacao-repasse-bndes-service';
import { BnUsuarioService, Usuario } from '@bndes/bndes-ux4/bn-usuario';
import { PermissaoService } from 'src/app/shared/permissao.service';
import { ROLE_GESTOR_CONSULTA } from 'src/app/constantes/permissao.constants';
import { debounceTime, filter, distinctUntilChanged, map, takeUntil } from 'rxjs';
import { Cnae, Dominio } from 'src/app/model/dominio-operacao.model';
import { ActivatedRoute } from '@angular/router';
import { Observable, of, Subject } from 'rxjs';
import { DominiosService } from 'src/app/shared/services/dominios.service';
import { OperacaoRepasseBndes, TIPOS_PORTE_CLIENTE } from 'src/app/model/operacao-repasse.model';
import { AgenteFinanceiro } from 'src/app/model/agente-financeiro.model';
import { NaturezasJuridicasAceitasService } from 'src/app/features/naturezas-juridicas-aceitas/naturezas-juridicas-aceitas.service';
import { ProgramasPermtidosPorCestasService } from 'src/app/features/programas-permitidos-por-cestas/programas-permitidos-por-cestas.service';
import { NaturezaJuridica } from 'src/app/model/natureza-juridica.model';
import { ProgramaRepasseBndes } from 'src/app/model/programas-permitidos.model';
import { ModalidadeOperacionalRepasseService } from './modalidade-operacional-repasse.service';
import { ModalidadeOperacionalRepasse } from 'src/app/model/modalidade-operacional-repasse';

@Component({
  selector: "app-operacao-repasse-bndes-cadastro",
  templateUrl: "./operacao-repasse-bndes-cadastro.component.html",
  styleUrls: ["./operacao-repasse-bndes-cadastro.component.scss"],
  standalone: false,
})
export class OperacaoRepasseBndesCadastroComponent
  extends BaseEntityComponent<OperacaoRepasseBndes>
  implements OnInit
{
  public percentuaisPorModalidade: number[];
  public classificacoesRisco = ["AA", "A", "B", "C", "D", "E", "F", "G", "H"];
  public composicoesGarantia = [
    {
      codigo: "FC",
      descricao: "Fidejussória prestada pelo(s) controladore(s)",
    },
    { codigo: "FT", descricao: "Fidejussória prestada por terceiro(s)" },
    {
      codigo: "FR",
      descricao: "Fidejussória prestada pelo(s) controladore(s) + real",
    },
    {
      codigo: "FF",
      descricao:
        "Fidejussória prestada pelo(s) controladore(s) + fidejussória prestada por terceiro(s)",
    },
    { codigo: "RE", descricao: "Real" },
    { codigo: "TR", descricao: "Fidejussória prestada por terceiro(s) + real" },
    {
      codigo: "TT",
      descricao:
        "Fidejussória prestada pelo(s) controladore(s) + fidejussória prestada por terceiro(s) + real",
    },
  ];

  public garantias = [
    { codigo: 1, descricao: "Real" },
    { codigo: 2, descricao: "Fidejussória" },
    { codigo: 3, descricao: "Cessão/Vinc. de Receita" },
    { codigo: 5, descricao: "Seguro de Crédito" },
    { codigo: 6, descricao: "Fiança entre Entidades" },
    { codigo: 7, descricao: "Project Finance" },
    { codigo: 8, descricao: "Penhor (Bens ou Ações)" },
    { codigo: 9, descricao: "Caução" },
    { codigo: 12, descricao: "Propriedade Fiduciária" },
    { codigo: 13, descricao: "Hipoteca" },
    { codigo: 15, descricao: "Fiança Bancária" },
    { codigo: 16, descricao: "Fiança Pessoal" },
    { codigo: 17, descricao: "Fiança Corporativa" },
    { codigo: 20, descricao: "Aval" },
    { codigo: 21, descricao: "Endosso com Regresso" },
    { codigo: 22, descricao: "Penhor de Ações" },
    { codigo: 23, descricao: "Cessão Fiduciária de Direitos Cred." },
    { codigo: 24, descricao: "Cessão Fiduciária de Direitos Emerg" },
    { codigo: 25, descricao: "Penhor de Direitos Creditórios" },
    { codigo: 26, descricao: "Penhor de Direitos Emergentes" },
    { codigo: 99, descricao: "Sem Garantia" },
  ];

  public operacaoRepasse: OperacaoRepasseBndes;
  public tiposFGI: string[] = ["Somado ao Saldo", "Dentro do Saldo", "Boleto"];
  public tipoOperacoes = [TipoOperacaoEnum.REPASSE];
  public portesClienteFinal = TIPOS_PORTE_CLIENTE;
  public agentesFinanceiros: AgenteFinanceiro[] = [];
  public modalidadeGarantia: string;
  public modalidadeGarantiaDTO: ModalidadeGarantia;
  public dataCorrente = new Date();
  public dataFuturaPrimeiraAmortizacao: Date;
  public dataFuturaUltimaAmortizacao: Date;
  public permissaoEnvio: boolean;
  public formOperacaoRepasse: FormGroup;
  public cobrancaEcgEstaAtiva: boolean;
  public dadosDominio: Dominio;
  public cnaeClienteFinal: string;
  public nomeCnaeClienteFinal: string;
  public naturezasJuridicasAceitas: NaturezaJuridica[] = [];
  public programasAceitos: ProgramaRepasseBndes[] = [];
  public modalidadesOperacionaisAceitas: ModalidadeOperacionalRepasse[] = [];

  private readonly destroy$ = new Subject();

  constructor(
    public formBuilder: UntypedFormBuilder,
    private modalidadeService: ModalidadeService,
    private modalidadeGarantiaService: ModalidadeGarantiaService,
    protected injector: Injector,
    private operacaoRepasseService: OperacaorepasseBndesService,
    private usuarioService: BnUsuarioService,
    private permissaoService: PermissaoService,
    private activatedRoute: ActivatedRoute,
    private dominiosService: DominiosService,
    private naturezaJuridicaAceitaService: NaturezasJuridicasAceitasService,
    private programasPermtidosPorCestasService: ProgramasPermtidosPorCestasService,
    private modalidadeOperacionalRepasseService: ModalidadeOperacionalRepasseService
  ) {
    super(operacaoRepasseService);
  }

  ngOnInit(): void {
    this.dataFuturaPrimeiraAmortizacao = this.adicionaDias(this.dataCorrente, 1);
    this.dataFuturaUltimaAmortizacao = this.dataFuturaPrimeiraAmortizacao;

    this.dadosDominio = this.activatedRoute.snapshot.data["dominios"];
    this.agentesFinanceiros = this.activatedRoute.snapshot.data["agentes"];

    this.permissaoService
      .getPermissoesUsuarioAutenticado()
      .subscribe((resp) => {
        this.permissaoEnvio = resp && resp[ROLE_GESTOR_CONSULTA];
      });

    this.modalidadeService.modalidade$.subscribe(
      (modalidade) => (this.modalidadeGarantia = modalidade)
    );

    this.modalidadeGarantiaService
      .buscarModalidade()
      .subscribe((modalidade: ModalidadeGarantia) => {
        this.percentuaisPorModalidade =
          modalidade.percentuaisGarantiaPermitidos;
        this.cobrancaEcgEstaAtiva = modalidade.cobrancaEcgEstaAtiva;
      });
    this.construirFormulario();
    this.alterarValidadorDoPrazoCarencia();
    this.verificarValidadeDatas();
    this.verificarApenasUmCampo("riscoOperacao", "valorPerdaEsperada");

    this.naturezaJuridicaAceitaService
      .buscarNaturezas()
      .subscribe((naturezas) => {
        this.naturezasJuridicasAceitas = naturezas;
      });

    this.programasPermtidosPorCestasService
      .buscarProgramasPermitidosTrancheAtual()
      .subscribe((programas) => {
        this.programasAceitos = programas;
      });

    this.modalidadeOperacionalRepasseService
      .buscarModalidadesPermitidas()
      .subscribe((modalidades) => {
        this.modalidadesOperacionaisAceitas = modalidades;
      });

      this.formOperacaoRepasse.get('taxaIntermediacaoBNDES')?.valueChanges.subscribe(() => this.recalcularTaxaRemuneracaoBndes());
      this.formOperacaoRepasse.get('taxaRemuneracaoBasicaBNDES')?.valueChanges.subscribe(() => this.recalcularTaxaRemuneracaoBndes());
      
      this.formOperacaoRepasse.get('taxaCustoFinanceiroAdicional')?.valueChanges.subscribe(() => this.recalcularTaxaReferencialCustoFinanceiro());
      this.formOperacaoRepasse.get('taxaRemuneracaoBNDES')?.valueChanges.subscribe(() => this.recalcularTaxaReferencialCustoFinanceiro());

      // tenta buscar a operacao se o usuario digitou mais de 5 caracteres apos 2s
      this.formOperacaoRepasse.get("idProtocoloBNDES")!.valueChanges.pipe(
          debounceTime(3000),
          filter(value => value && value.length > 5)
        )
        .subscribe((value) => {
          this.preencherFormulario();
        });
    }

  construirFormulario() {
    this.formOperacaoRepasse = this.formBuilder.group({
      //Aba Operação Garantida
      idProtocoloBNDES: [
        "",
        [Validators.maxLength(17), Validators.pattern(/^[a-zA-Z0-9]+$/)],
      ],
      sistemaOrigem: "",
      cnpjAgenteFinanceiro: ["", Validators.pattern(/^[A-Za-z0-9]{14}$/)],
      valorOperacao: ["", Validators.min(100.0)],
      percentualGarantido: [
        this.percentuaisPorModalidade ? this.percentuaisPorModalidade[0] : "80",
        [Validators.min(0), Validators.max(90)],
      ],
      riscoOperacao: "",
      composicaoGarantia: "",
      valorPerdaEsperada: ["", [Validators.min(0.0), Validators.max(10.0)]],
      dataContratacao: "",
      microEmpreendedor: { value: "N", disabled: true },
      idPrograma: [
        "",
        [Validators.pattern(/^[0-9]+$/), Validators.minLength(1)],
      ],
      idModalidadeOperacionalBndes: [
        "",
        [Validators.pattern(/^[0-9]+$/), Validators.minLength(1)],
      ],
      quantidadeMesesPrazoTotal: ["", Validators.min(0)],
      quantidadeMesesPrazoCarencia: ["", [Validators.min(1)]],
      pagamentoJurosCarencia: true,
      ideCustoFinanceiroProtocolo: 19, // REAL por default
      taxaSpreadAgente: ["", Validators.min(0)],
      taxaRemuneracaoBNDES: ["", Validators.min(0)],
      taxaIntermediacaoBNDES: ["", Validators.min(0)],
      taxaRemuneracaoBasicaBNDES: ["", Validators.min(0)],
      taxaCustoFinanceiroAdicional: ["", Validators.min(0)],
      taxaReferencialCustoFinanceiro: ["", Validators.min(0)],
      principalGarantiaOperacao: ["", [Validators.maxLength(4)]],
      percentualCobertoGarantiaPrincipal: [
        "",
        [Validators.min(0), Validators.max(100)],
      ],
      sistemaCobranca: "",
      contratoCobranca: [null, [Validators.pattern(/^\d{11}$/)]],
      dataPrimeiraAmortizacao: { value: null, disabled: true },
      dataUltimaAmortizacao: { value: null, disabled: true },

      //Aba Cliente
      cnpjClienteFinal: ["", Validators.pattern(/^[A-Za-z0-9]{14}$/)],
      cnaeClienteFinal: ["", Validators.pattern(/^[A-Za-z][0-9]{7}$/)],
      receitaBrutaClienteFinal: ["", Validators.min(0)],
      tipoReceitaBruta: "",
      dataReferenciaReceitaBruta: "",
      idPorteClienteFinal: ["", [Validators.minLength(1)]],
      naturezaEmpresa: [null],
    });

    for (let key in this.formOperacaoRepasse.controls) {
      //Validators.required apenas para os que são obrigatórios
      if (
        ![
          "sistemaCobranca",
          "contratoCobranca",
          "dataContratacao",
          "dataPrimeiraAmortizacao",
          "dataUltimaAmortizacao",
          "composicaoGarantia",
          "principalGarantiaOperacao",
          "percentualCobertoGarantiaPrincipal",
          "riscoOperacao",
          "valorPerdaEsperada",
          "pagamentoJurosCarencia",
          "taxaReferencialCustoFinanceiro"
        ].includes(key)
      ) {
        this.formOperacaoRepasse.get(key)?.addValidators([Validators.required]);
      }
    }
  }

  protocolar(apenasValidacao: boolean) {
    const operacaoRepasse = this.preencherOperacaoRepasse();
    operacaoRepasse.reprocessamento = 'S'; // permite sobrescrita de dados no protocolo

    super.antesDeSalvar();

    this.operacaoRepasseService
      .protocolar(operacaoRepasse, apenasValidacao)
      .subscribe((res) => {
        super.aposSalvar();

        this.messageService.addMessage({
          title: "Sucesso",
          type: "CRUD_OPERATION",
          level: messageLevel.SUCCESS,
          message:
            "Operação " +
            (apenasValidacao ? "validada" : "protocolada") +
            " com sucesso.",
        });
      });
  }

  contratar() {
    const operacaoRepasse = this.preencherOperacaoRepasse();

    super.antesDeSalvar();

    this.operacaoRepasseService
      .contratar(operacaoRepasse, false)
      .subscribe((res) => {
        super.aposSalvar();

        this.messageService.addMessage({
          title: "Sucesso",
          type: "CRUD_OPERATION",
          level: messageLevel.SUCCESS,
          message: "Operação contratada com sucesso.",
        });
      });
  }

  preencherOperacaoRepasse() {
    return {
      ...this.formOperacaoRepasse.value,
      codigoTipoOperacao: "R",
      pagamentoJurosCarencia: this.formOperacaoRepasse.get("pagamentoJurosCarencia").value || false,
      composicaoGarantia: this.formOperacaoRepasse.get("composicaoGarantia").value || null,
      dataReferenciaProtocolo: new Date().toISOString(),
      dataEnvio: new Date().toISOString(),
      indicadorMicroempreendedorIndividual: "N",
      // a entrada da informacao tanto do risco quanto da perda esperada vai no campo de risco :|
      riscoOperacao: this.formOperacaoRepasse.get("riscoOperacao").value || this.formOperacaoRepasse.get("valorPerdaEsperada").value,
      clienteFinalPessoaFisica: false,
      idNaturezaEmpresa: this.formOperacaoRepasse.get("naturezaEmpresa")?.value.idN02,
      idComplementoNaturezaEmpresa: this.formOperacaoRepasse.get("naturezaEmpresa")?.value.idComplementoN02,
    };
  }
  
  camposObrigatoriosPreenchidos() {
     return !this.formOperacaoRepasse.get('valorPerdaEsperada').value || !this.formOperacaoRepasse.get('riscoOperacao').value;
  }

  podeCancelar() {
    return (this.operacaoRepasse?.sistemaOrigem === 'N03') && (this.operacaoRepasse?.detalhe?.estado?.id == 1)
  }

  cancelar() {
    const operacaoRepasse = this.preencherOperacaoRepasse();

    super.antesDeSalvar();

    this.operacaoRepasseService
      .cancelar(this.operacaoRepasse.id)
      .subscribe((res) => {
        super.aposSalvar();

        this.messageService.addMessage({
          title: "Sucesso",
          type: "CRUD_OPERATION",
          level: messageLevel.SUCCESS,
          message: "Operação cancelada com sucesso.",
        });
      });
  }

  podeContratar() {
    for (let key of [
      "sistemaCobranca",
      "contratoCobranca",
      "dataPrimeiraAmortizacao",
      "dataUltimaAmortizacao",
      "taxaReferencialCustoFinanceiro",
      "dataContratacao"
    ]) {
      if (!this.formOperacaoRepasse.get(key).value) return false;
    }
    return true;
  }

  formataCnae = (result: Cnae) => result.codigo + " - " + result.nome;

  atribuiCnaeClienteFinal(obj) {
    this.cnaeClienteFinal = obj.item.codigo;
    this.nomeCnaeClienteFinal = obj.item.nome;
    this.formOperacaoRepasse
      .get("cnaeClienteFinal")
      ?.setValue(this.cnaeClienteFinal);
  }

  procuraCnae = (text$: Observable<string>) =>
    text$.pipe(
      debounceTime(200),
      distinctUntilChanged(),
      map((term) =>
        term.length < 2
          ? []
          : this.dadosDominio.cnaes
              .filter(
                (v) =>
                  v.nome.toLowerCase().indexOf(term.toLowerCase()) > -1 ||
                  v.codigo.toLowerCase().indexOf(term.toLowerCase()) > -1
              )
              .slice(0, 10)
      )
    );

  recalcularTaxaRemuneracaoBndes() {
    const taxaIntermediacaoBNDES = Number(this.formOperacaoRepasse.get("taxaIntermediacaoBNDES").value || 0);
    const taxaRemuneracaoBasicaBNDES = Number(this.formOperacaoRepasse.get("taxaRemuneracaoBasicaBNDES").value || 0);

    const taxaRemuneracaoBNDES = taxaIntermediacaoBNDES + taxaRemuneracaoBasicaBNDES;

    this.formOperacaoRepasse.get('taxaRemuneracaoBNDES')?.setValue(taxaRemuneracaoBNDES, { emitEvent: false });
  }

  recalcularTaxaReferencialCustoFinanceiro() {
    const taxaCustoFinanceiroAdicional = Number(this.formOperacaoRepasse.get("taxaCustoFinanceiroAdicional").value || 0);
    const taxaRemuneracaoBNDES = Number(this.formOperacaoRepasse.get("taxaRemuneracaoBNDES").value || 0);

    const taxaReferencialCustoFinanceiro = ((1 + taxaCustoFinanceiroAdicional/100.0) * (1 + taxaRemuneracaoBNDES/100.0) - 1) * 100.00;

    this.formOperacaoRepasse.get('taxaReferencialCustoFinanceiro')?.setValue(taxaReferencialCustoFinanceiro, { emitEvent: false });
  }

  alterarValidadorDoPrazoCarencia() {
    const prazoTotalControl = this.formOperacaoRepasse.get("quantidadeMesesPrazoTotal");
    const prazoCarenciaControl = this.formOperacaoRepasse.get("quantidadeMesesPrazoCarencia");

    prazoTotalControl.valueChanges.subscribe((prazoTotal) => {
      if (prazoTotal && prazoTotal > 0) {
        prazoCarenciaControl.setValidators([
          Validators.required,
          Validators.min(0),
          Validators.max(prazoTotal - 1),
        ]);
      } else {
        prazoCarenciaControl.setValidators([
          Validators.required,
          Validators.min(0),
        ]);
      }
      prazoCarenciaControl.updateValueAndValidity();
    });
  }

  verificarValidadeDatas() {
    const contratacaoCtrl = this.formOperacaoRepasse.get("dataContratacao");
    const primeiraAmortCtrl = this.formOperacaoRepasse.get(
      "dataPrimeiraAmortizacao"
    );
    const ultimaAmortCtrl = this.formOperacaoRepasse.get(
      "dataUltimaAmortizacao"
    );

    contratacaoCtrl.valueChanges.subscribe((novaData) => {
      if (contratacaoCtrl.valid && novaData) {
        if (typeof novaData === "string") novaData = new Date(novaData);

        primeiraAmortCtrl.enable();
        if (novaData?.getTime() > new Date().getTime()) {
          this.dataFuturaPrimeiraAmortizacao = this.adicionaDias(novaData, 1);
        } else {
          this.dataFuturaPrimeiraAmortizacao = this.adicionaDias(
            this.dataCorrente,
            1
          );
          this.dataFuturaUltimaAmortizacao = this.dataFuturaPrimeiraAmortizacao;
        }
      } else {
        primeiraAmortCtrl.disable();
      }
      primeiraAmortCtrl.reset();
    });

    primeiraAmortCtrl.valueChanges.subscribe((novaData) => {
      if (primeiraAmortCtrl.valid && novaData) {
        if (typeof novaData === "string") novaData = new Date(novaData);

        ultimaAmortCtrl.enable();
        this.dataFuturaUltimaAmortizacao = this.dataFuturaPrimeiraAmortizacao;
      } else {
        ultimaAmortCtrl.disable();
      }
      ultimaAmortCtrl.reset();
    });
  }

  verificarApenasUmCampo(control1: string, control2: string) {
    const formControl1 = this.formOperacaoRepasse.get(control1);
    const formControl2 = this.formOperacaoRepasse.get(control2);

    if (!formControl1 || !formControl2) return;

    formControl1.valueChanges.subscribe((novoValor) => {
      if (novoValor) {
        formControl2.reset();
      }
    });
    formControl2.valueChanges.subscribe((novoValor) => {
      if (novoValor) {
        formControl1.reset();
      }
    });
  }

  adicionaDias(dataAntiga: Date, quantidadeDias: number = 1) {
    const novaData = new Date(dataAntiga);
    novaData.setDate(dataAntiga.getDate() + quantidadeDias);
    return novaData;
  }

  preencherFormulario() {
    if (!this.formOperacaoRepasse.get("idProtocoloBNDES").value) {
      return;
    }

    const idOperacao = this.formOperacaoRepasse.get("idProtocoloBNDES").value;
    this.operacaoRepasseService
      .buscarOperacaoParaCadastroPorTela(idOperacao)
      .subscribe((operacaoRepasse) => {
        this.operacaoRepasse = operacaoRepasse;
        const naturezaEmpresaOperacao = this.naturezasJuridicasAceitas.find(
          (n) => n.idN02 === operacaoRepasse.idNaturezaEmpresa
        );

        const ehPerdaEsperada =  /^\d+([.,]\d+)?$/;

        this.formOperacaoRepasse.patchValue({
          sistemaOrigem: operacaoRepasse.sistemaOrigem,
          cnpjAgenteFinanceiro: operacaoRepasse.cnpjAgenteFinanceiro,
          valorOperacao: operacaoRepasse.valorOperacao,
          percentualGarantido: Math.floor(operacaoRepasse.percentualGarantido),          
          composicaoGarantia: operacaoRepasse.composicaoGarantia,
          // o mapper ta retornando risco ou perda esperada no campo de risco :|
          riscoOperacao: !ehPerdaEsperada.test(operacaoRepasse.riscoOperacao) ? operacaoRepasse.riscoOperacao : null,
          valorPerdaEsperada: ehPerdaEsperada.test(operacaoRepasse.riscoOperacao) ? operacaoRepasse.riscoOperacao : null,
          dataContratacao: operacaoRepasse.dataContratacao
            ? new Date(operacaoRepasse.dataContratacao)
            : null,
          idPrograma: operacaoRepasse.idPrograma,
          idModalidadeOperacionalBndes: operacaoRepasse.idModalidadeOperacionalBndes,
          quantidadeMesesPrazoTotal: operacaoRepasse.quantidadeMesesPrazoTotal,
          quantidadeMesesPrazoCarencia: operacaoRepasse.quantidadeMesesPrazoCarencia,
          pagamentoJurosCarencia: true, // esta informacao nao eh persistida - entao preenchemos com o default
          ideCustoFinanceiroProtocolo: operacaoRepasse.ideCustoFinanceiroProtocolo,
          taxaSpreadAgente: Number(operacaoRepasse.taxaSpreadAgente)?.toFixed(2),
          taxaRemuneracaoBNDES: Number(operacaoRepasse.taxaRemuneracaoBNDES)?.toFixed(2),
          taxaIntermediacaoBNDES: Number(operacaoRepasse.taxaIntermediacaoBNDES)?.toFixed(2),
          taxaRemuneracaoBasicaBNDES: Number(operacaoRepasse.taxaRemuneracaoBasicaBNDES)?.toFixed(2),
          taxaCustoFinanceiroAdicional: Number(operacaoRepasse.taxaCustoFinanceiroAdicional)?.toFixed(2),
          taxaReferencialCustoFinanceiro: Number(operacaoRepasse.taxaReferencialCustoFinanceiro)?.toFixed(2),
          principalGarantiaOperacao: operacaoRepasse.principalGarantiaOperacao,
          percentualCobertoGarantiaPrincipal: operacaoRepasse.percentualCobertoGarantiaPrincipal,
          cnpjClienteFinal: operacaoRepasse.cnpjClienteFinal,
          cnaeClienteFinal: operacaoRepasse.cnaeClienteFinal,
          receitaBrutaClienteFinal: operacaoRepasse.receitaBrutaClienteFinal,
          tipoReceitaBruta: operacaoRepasse.tipoReceitaBruta,
          dataReferenciaReceitaBruta: operacaoRepasse.dataReferenciaReceitaBruta
            ? new Date(operacaoRepasse.dataReferenciaReceitaBruta)
            : null,
          idPorteClienteFinal: operacaoRepasse.idPorteClienteFinal,
          sistemaCobranca: operacaoRepasse.sistemaCobranca || "",
          contratoCobranca: operacaoRepasse.contratoCobranca || null,
          dataPrimeiraAmortizacao: operacaoRepasse.dataPrimeiraAmortizacao
            ? new Date(operacaoRepasse.dataPrimeiraAmortizacao)
            : null,
          dataUltimaAmortizacao: operacaoRepasse.dataUltimaAmortizacao
            ? new Date(operacaoRepasse.dataUltimaAmortizacao)
            : null,
          naturezaEmpresa: naturezaEmpresaOperacao,
        });

        if (operacaoRepasse.cnaeClienteFinal) {
          this.procuraCnae(of(operacaoRepasse.cnaeClienteFinal)).subscribe(
            (cnae) => {
              this.cnaeClienteFinal = cnae[0].codigo;
              this.nomeCnaeClienteFinal = cnae[0].nome;
            }
          );
        }

        for (const field in this.formOperacaoRepasse.controls) {
          const control = this.formOperacaoRepasse.get(field);
          if (control && control.invalid) {
            console.log(`${field} is invalid`, control.errors);
          }
        }
      },
      (error) => {
        console.log('Nao foi possivel encontrar a operacao.');
      });
  }

  compararNaturezas = (a: NaturezaJuridica, b: NaturezaJuridica) => {
    return (
      a && b && a.idN02 === b.idN02 && a.idComplementoN02 === b.idComplementoN02
    );
  };
}
